
function Copyright() {
  return <>© Sandoll Metalab</>;
};

export default Copyright;
